import { render, staticRenderFns } from "./price-list-page.vue?vue&type=template&id=a3fd5b82&"
import script from "./price-list-page.vue?vue&type=script&lang=js&"
export * from "./price-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports